<div class="vb-wrapper">

    <!-- ── ORDER SUMMARY CARD ── -->
    <div class="order-summary-card">
      <div class="summary-row">
        <div class="summary-item">
          <span class="summary-label">Order No</span>
          <span class="summary-value highlight">{{ order?.orderNumber || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Route</span>
          <span class="summary-value">{{ order?.route || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">No. of Vehicles</span>
          <span class="summary-value">{{ order?.numberOfVehicles || order?.numberOfVehicle || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Procurement Price</span>
          <span class="summary-value green">₹{{ order?.procurementPrice || order?.procurementProvidedAmount || 0  }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Status</span>
          <span class="summary-value">
            <span class="status-chip" [ngClass]="statusClass(order?.status)">
              {{ order?.status || '--' }}
            </span>
          </span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Vehicle Required At</span>
          <span class="summary-value">{{ order?.vehicleRequiredAt | CustomDatePipe: '' }}</span>
        </div>
      </div>
    </div>
  
    <!-- ── VENDOR BIDS LIST ── -->
    <div class="section-title-row">
      <span class="section-title">Vendor Bids</span>
      <span class="bid-count">{{ vendorBids.length }} bids received</span>
    </div>
  
    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i> Loading bids...
    </div>
  
    <!-- Empty -->
    <div *ngIf="!isLoading && vendorBids.length === 0" class="empty-state">
      <i class="pi pi-inbox empty-icon"></i>
      <p>No bids received yet</p>
    </div>
  
    <!-- Bids Table -->
    <div class="bids-table-wrap" *ngIf="!isLoading && vendorBids.length > 0">
      <table class="bids-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Vendor Name</th>
            <th>Bid Amount</th>
            <th>Vehicles Provided</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let bid of vendorBids; let i = index"
            class="bid-row"
            [class.row-accepted]="bid?.status?.includes('Accepted')"
            [class.row-rejected]="bid?.status?.includes('Rejected')"
            (click)="openCompare(bid)">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="vendor-info">
                <span class="vendor-avatar">{{ (bid?.vendorName || 'V')[0] | uppercase }}</span>
                <span class="vendor-name">{{ bid?.vendorName || '--' }}</span>
              </div>
            </td>
            <td>
              <span class="bid-amount">₹{{ bid?.bidAmount || bid?.procurementPrice || '--'  }}</span>
            </td>
            <td>{{  bid?.numberOfVehicle || bid?.vehicleProvided || '--' }}</td>
            <td>
              <span class="status-chip" [ngClass]="statusClass(bid?.status)">
                {{ statusLabel(bid?.status) }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn-compare"
                (click)="openCompare(bid); $event.stopPropagation()">
                View Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
  </div>
  
  
  <!-- ═══════════════════════════════════════
       COMPARE POPUP — old vs new amount
  ════════════════════════════════════════ -->
  <p-dialog
    [(visible)]="showCompareDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '30vw' }"
    styleClass="compare-dialog"
    (onHide)="closeCompare()">
  
    <ng-template pTemplate="header">
      <div class="compare-header">
        <span class="compare-tag">🏷️ RATE COMPARISON</span>
        <div class="compare-vendor">{{ selectedBid?.vendorName || 'Vendor' }}</div>
      </div>
    </ng-template>
  
    <div class="compare-body" *ngIf="selectedBid">
  
      <div class="compare-cols">
  
        <!-- Left: Customer — editable when PendingOnCustomer -->
        <div class="compare-col">
            <div class="col-header customer-header">
            <span class="col-icon">🏢</span>
            <div>
                <div class="col-title">Customer</div>
                <div class="col-badge" *ngIf="selectedBid?.status !== 'PendingOnCustomer'">🔒 read-only</div>
                <div class="col-badge editable-badge" *ngIf="selectedBid?.status === 'PendingOnCustomer'">✏️ editable</div>
            </div>
            </div>
        
            <!-- Read-only when NOT PendingOnCustomer -->
            <ng-container *ngIf="selectedBid?.status !== 'PendingOnCustomer'">
            <div class="compare-field">
                <label>PROCUREMENT PRICE</label>
                <div class="amount-box readonly">
                <span class="currency">₹</span>
                <span class="amount-val">{{ order?.procurementPrice || order?.procurementProvidedAmount || 0 | number }}</span>
                </div>
            </div>
        
            <div class="compare-field">
                <label>NO. OF VEHICLES</label>
                <div class="amount-box readonly">
                <span class="amount-val">{{ order?.numberOfVehicles || order?.numberOfVehicle || 1 }}</span>
                </div>
            </div>
            </ng-container>
        
            <!-- Editable when PendingOnCustomer -->
            <ng-container *ngIf="selectedBid?.status === 'PendingOnCustomer'" [formGroup]="counterBidForm">
            <div class="compare-field">
                <label>COUNTER BID AMOUNT <span style="color:red">*</span></label>
                <div class="amount-input-box">
                <span class="currency">₹</span>
                <input
                    type="number"
                    class="amount-input"
                    placeholder="Enter amount"
                    formControlName="counterBidAmount" />
                </div>
                <small class="err" *ngIf="counterBidForm.get('counterBidAmount')?.touched && counterBidForm.get('counterBidAmount')?.invalid">
                Required
                </small>
            </div>
        
            <div class="compare-field">
                <label>NO. OF VEHICLES</label>
                <div class="amount-input-box">
                <input
                    type="number"
                    class="amount-input"
                    placeholder="1"
                    formControlName="counterVehicles" />
                </div>
            </div>
            </ng-container>
        </div>
  
        <!-- Right: Vendor Bid (read-only) -->
        <div class="compare-col">
            <div class="col-header vendor-header">
            <span class="col-icon">🚛</span>
            <div>
                <div class="col-title">Vendor</div>
                <div class="col-badge">🔒 read-only</div>
            </div>
            </div>
        
            <div class="compare-field">
            <label>BID AMOUNT</label>
            <div class="amount-box readonly bid"
                [class.higher]="selectedBid?.bidAmount > (order?.procurementPrice || order?.procurementProvidedAmount)"
                [class.lower]="selectedBid?.bidAmount < (order?.procurementPrice || order?.procurementProvidedAmount)">
                <span class="currency">₹</span>
                <span class="amount-val">{{ selectedBid?.bidAmount || 0 | number }}</span>
                <span class="diff-badge" *ngIf="selectedBid?.bidAmount && (order?.procurementPrice || order?.procurementProvidedAmount)">
                {{ selectedBid.bidAmount > (order?.procurementPrice || order?.procurementProvidedAmount) ? '▲' : '▼' }}
                {{ ((selectedBid.bidAmount - (order?.procurementPrice || order?.procurementProvidedAmount)) | number) }}
                </span>
            </div>
            </div>
        
            <div class="compare-field">
            <label>VEHICLES PROVIDED</label>
            <div class="amount-box readonly">
                <span class="amount-val">{{ selectedBid?.vehicleProvided || selectedBid?.numberOfVehicle || 1 }}</span>
            </div>
            </div>
        </div>
  
      </div>
  
      <!-- Status row -->
      <div class="compare-status-row">
        <span class="compare-status-label">Current Status:</span>
        <span class="status-chip" [ngClass]="statusClass(selectedBid?.status)">
          {{ statusLabel(selectedBid?.status) }}
        </span>
      </div>
    </div>
  
    <ng-template pTemplate="footer">
        <div class="compare-footer" *ngIf="selectedBid?.status !== 'AcceptedByCustomer' && selectedBid?.status !== 'PendingOnVendor'">
          <button type="button" class="btn btn-reject-action" [disabled]="actionLoading" (click)="onAction('RejectedByCustomer')">
            ✕ Reject
          </button>
      
          <!-- Bidding button — only when PendingOnCustomer -->
          <button
            *ngIf="selectedBid?.status === 'PendingOnCustomer'"
            type="button"
            class="btn btn-bidding-action"
            [disabled]="actionLoading || counterBidForm.invalid"
            (click)="onCounterBid()">
            🏷️ Bidding
          </button>
      
          <button type="button" class="btn btn-accept-action" [disabled]="actionLoading" (click)="onAction('AcceptedByCustomer')">
            ✓ Accept
          </button>
        </div>
      </ng-template>
  
  </p-dialog>